import { useOidc } from "@axa-fr/react-oidc"
import { Button } from "@janeapp/burrito-design-system"
import { formatDate, millisToDate } from "core"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { AccountContext } from "../../context/AccountContext"
import { AccountCard, CardError, Field } from "./AccountCard"

export const SignInInformation = () => {
  const { login } = useOidc()
  const { t, i18n } = useTranslation()
  const { profile, passwordUpdatedAt, loading, errors } =
    useContext(AccountContext)

  // Keycloak owns both flows, so each button hands off to a required action
  // rather than editing anything in place.
  const startKeycloakAction = (action: string) =>
    login(undefined, { kc_action: action, ui_locales: i18n.language })

  const updateButton = (action: string, label: string) => (
    <Button onClick={() => startKeycloakAction(action)} aria-label={label}>
      {t("loginSecurity.update")}
    </Button>
  )

  const passwordSubtitle = passwordUpdatedAt
    ? t("loginSecurity.lastUpdated", {
        date: formatDate(millisToDate(passwordUpdatedAt), i18n.language),
      })
    : ""

  return (
    <AccountCard title={t("loginSecurity.emailPassword")}>
      {errors.profile ? (
        <CardError />
      ) : (
        <Field
          label={t("loginSecurity.loginEmail")}
          value={profile?.email}
          isLoading={loading}
          action={updateButton("UPDATE_EMAIL", t("loginSecurity.loginEmail"))}
        />
      )}
      {errors.password ? (
        <CardError />
      ) : (
        <Field
          label={t("loginSecurity.password")}
          value={passwordSubtitle}
          isLoading={loading}
          action={updateButton("UPDATE_PASSWORD", t("loginSecurity.password"))}
        />
      )}
    </AccountCard>
  )
}
